import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'


const _hoisted_1 = {
  style: {"width":"55rem","max-width":"80vw","max-height":"22rem"},
  class: "relative pt-6 edit-body overflow-y-auto"
}
const _hoisted_2 = { class: "flex flex-row items-center justify-center gap-x-6" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "w-3/20" }, [
  /*#__PURE__*/_createVNode("p", {
    class: "text-20px font-normal text-left",
    style: {"margin-left":"-1.7rem"}
  }, " Total Koli ")
], -1)
const _hoisted_4 = { style: {"width":"51%"} }
const _hoisted_5 = { class: "" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "my-6" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_7 = { class: "flex flex-row items-center justify-center gap-4 gap-y-2" }
const _hoisted_8 = {
  key: 0,
  class: "flex flex-row ml-8"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4.5 max-w-none",
  alt: "exclamation tiangle red"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("p", { class: "text-red-lp-100 text-12px xxl:text-14px flex pl-1 gap-x-2" }, " Nilai koli lebih besar dari total koli, ubah dan simpan dengan nilai yang sama ", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "mt-6" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_12 = {
  key: 0,
  class: "flex flex-row ml-8 items-center"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4 max-w-none",
  alt: "exclamation tiangle red"
}, null, -1)
const _hoisted_14 = { class: "text-red-lp-100 text-12px xxl:text-14px flex pl-1 gap-x-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_InputDimension = _resolveComponent("InputDimension")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    modelValue: _ctx.showPopupDimensionPieces,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.showPopupDimensionPieces = $event)),
    onReset: _ctx.resetPopupDetailPieces,
    persistent: "",
    title: "Ubah Dimensi Koli",
    customBody: "py-3",
    showOverflow: ""
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            (!_ctx.disabledPieces)
              ? (_openBlock(), _createBlock(_component_lp_input, {
                  key: 0,
                  "data-testid": "cargo-quantity-input-pieces",
                  isErrorIconInput: false,
                  isErrorIconCaption: false,
                  error: _ctx.isErrorInputNol.totalPieces,
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setErrorIndex(_ctx.formDetailPieces.dimensionPieces.length - 1))),
                  modelValue: _ctx.formDetailPieces.totalPieces,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formDetailPieces.totalPieces = $event)),
                  format: _ctx.formatPieces
                }, null, 8, ["error", "modelValue", "format"]))
              : (_openBlock(), _createBlock(_component_lp_input, {
                  key: 1,
                  isErrorIconInput: false,
                  isErrorIconCaption: false,
                  error: _ctx.isErrorInputNol.totalPieces,
                  modelValue: _ctx.totalPiecesDisplay,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.totalPiecesDisplay = $event)),
                  disabled: _ctx.disabledPieces,
                  disableBackground: _ctx.disabledPieces
                }, null, 8, ["error", "modelValue", "disabled", "disableBackground"]))
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode("div", null, [
              (_ctx.disabledPieces)
                ? (_openBlock(), _createBlock(_component_lp_button, {
                    key: 0,
                    onClick: _ctx.setDisabledPieces,
                    title: "Ubah",
                    outline: "",
                    customClass: "py-3 px-2",
                    textColor: "red-lp-100",
                    iconLeft: "icon-edit-dash"
                  }, null, 8, ["onClick"]))
                : (_openBlock(), _createBlock(_component_lp_button, {
                    key: 1,
                    textColor: "white",
                    title: "Simpan",
                    fontWeight: "semibold",
                    color: "red-lp-100",
                    customClass: "py-3 px-5",
                    onClick: _ctx.setDisabledPieces
                  }, null, 8, ["onClick"]))
            ])
          ])
        ]),
        _hoisted_6,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.formDetailPieces.dimensionPieces, (form, index) => {
          return (_openBlock(), _createBlock("div", { key: index }, [
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_DataWrapper, {
                label: "Nilai Koli",
                asterisk: "",
                class: "w-1/5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lp_input, {
                    isErrorIconInput: false,
                    isErrorIconCaption: false,
                    error: 
                (_ctx.errorMaxThanTotalPieces && _ctx.errorIndex === index) ||
                _ctx.isErrorInputNol.pieces && +form.pieces === 0
              ,
                    onChange: ($event: any) => (_ctx.setErrorIndex(index)),
                    modelValue: form.pieces,
                    "onUpdate:modelValue": ($event: any) => (form.pieces = $event),
                    format: _ctx.formatPieces
                  }, null, 8, ["error", "onChange", "modelValue", "onUpdate:modelValue", "format"])
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_DataWrapper, {
                label: "Dimensi",
                suffix: "P x L x T",
                asterisk: "",
                class: "w-6/20"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputDimension, {
                    class: "my-1.5",
                    onChange: ($event: any) => (
                {
                }
              ),
                    length: form.length,
                    "onUpdate:length": ($event: any) => (form.length = $event),
                    width: form.width,
                    "onUpdate:width": ($event: any) => (form.width = $event),
                    height: form.height,
                    "onUpdate:height": ($event: any) => (form.height = $event),
                    onInput: ($event: any) => (_ctx.onCalculateVolumeWeight(index)),
                    error: _ctx.isErrorInputNol.dimension && (+form.length === 0 || +form.width === 0 || +form.height === 0),
                    withIcon: false
                  }, null, 8, ["length", "onUpdate:length", "width", "onUpdate:width", "height", "onUpdate:height", "onInput", "error"])
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_DataWrapper, {
                label: "Berat Volume",
                asterisk: "",
                class: "w-1/5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lp_input, {
                    isErrorIconInput: false,
                    isErrorIconCaption: false,
                    onChange: _ctx.onResetAction,
                    modelValue: form.grossWeight,
                    "onUpdate:modelValue": ($event: any) => (form.grossWeight = $event),
                    suffix: "Kg",
                    format: _ctx.numberOnly,
                    error: _ctx.isErrorInputNol.volumeWeight && +form.grossWeight === 0
                  }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue", "format", "error"])
                ]),
                _: 2
              }, 1024),
              _createVNode("div", {
                class: `pt-5 flex flex-row w-1/6 ${
              _ctx.formDetailPieces.dimensionPieces.length > 1
                ? 'justify-center'
                : 'justify-start'
            }`
              }, [
                (
                (index === _ctx.formDetailPieces.dimensionPieces.length - 1 &&
                !_ctx.errorMaxThanTotalPieces) &&
               +_ctx.countPieces !== +_ctx.formDetailPieces.totalPieces
              )
                  ? (_openBlock(), _createBlock(_component_lp_button, {
                      key: 0,
                      onClick: _ctx.addPieces,
                      title: "Koli",
                      outline: "",
                      customClass: "py-3 px-0",
                      textColor: "red-lp-100",
                      iconLeft: "plus-square"
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.formDetailPieces.dimensionPieces.length > 1)
                  ? (_openBlock(), _createBlock(_component_Icons, {
                      key: 1,
                      onClick: ($event: any) => (_ctx.removePieces(index)),
                      name: "trash-concentrated",
                      class: `w-7 cursor-pointer ${
                index === _ctx.formDetailPieces.dimensionPieces.length - 1 ||
                !_ctx.errorMaxThanTotalPieces
                  ? 'ml-2'
                  : ''
              } text-red-lp-100`
                    }, null, 8, ["onClick", "class"]))
                  : _createCommentVNode("", true)
              ], 2)
            ]),
            (_ctx.errorMaxThanTotalPieces && _ctx.errorIndex === index)
              ? (_openBlock(), _createBlock("div", _hoisted_8, [
                  _hoisted_9,
                  _hoisted_10
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _hoisted_11,
      _createVNode("div", {
        class: `w-full flex ${
        _ctx.errorLessThanTotalPieces || _ctx.errorInputNol ? 'justify-between ' : 'justify-end'
      } pr-6 pt-6 pb-4`
      }, [
        (_ctx.errorLessThanTotalPieces || _ctx.errorInputNol)
          ? (_openBlock(), _createBlock("div", _hoisted_12, [
              _hoisted_13,
              _createVNode("p", _hoisted_14, _toDisplayString(_ctx.errorLessThanTotalPieces
              ? "Nilai koli lebih kecil dari total koli, ubah dan simpan dengan nilai yang sama"
              : "Total Koli, Nilai Koli, Dimensi, dan Berat Volume harus diiisi"), 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_lp_button, {
          textColor: "white",
          title: "Simpan",
          fontWeight: "semibold",
          color: "red-lp-100",
          customClass: "py-2 px-8",
          onClick: _ctx.onSubmitPoupDetailPieces
        }, null, 8, ["onClick"])
      ], 2)
    ]),
    _: 1
  }, 8, ["modelValue", "onReset"]))
}